<template>
</template>

<script>
import { obrazecService } from '../services/obrazec.service';

export default {
    props:['datotekaid'],
    created () {

    
        obrazecService.vrniDatoteko(this.datotekaid).then(datoteka=>{
                console.log(datoteka);
            });
 
    },

    methods: {
      
     

        
    }
};
</script>

